// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-map-select-button,.data-map-select-button:hover{color:#4066d4!important}", ""]);
// Exports
module.exports = exports;
